import { AboutUsDocument } from "../../model/AboutUsDocument";
import { AboutUsDocumentRepository } from "../../repositories/Repository";

export class GetAboutUsDocumentUseCase {
    constructor(private aboutUsDocumentRepository: AboutUsDocumentRepository) { }
  
    async execute(): Promise<AboutUsDocument[]> {
      return await this.aboutUsDocumentRepository.getAboutUsDocument();
    }
  }